import { Inject } from 'inversify-props'
import type { BaixaDePagamentoServiceAdapter } from "./adapter";

export class DeleteBaixaDePagamentoUseCase {
	@Inject('BaixaDePagamentoServiceAdapter')
	private baixaDePagamentoServiceAdapter!: BaixaDePagamentoServiceAdapter

	execute = async (id: string): Promise<void> =>
		await this.baixaDePagamentoServiceAdapter.delete(id)
}